// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__zvZfs","action":"Footer_action__HHbw2","icon":"Footer_icon__BA67O"};